import styled, { css } from 'styled-components';

interface ListItemProps {
  selected: boolean;
}

/**
 * @deprecated Will be converted to Tailwind shortly - currently 22 references
 */
export const ListItem = styled('li')<ListItemProps>`
  font-size: ${({ theme }) => theme.x2space - 0.2}rem;
  display: inline-block;
  height: 54px;
  > a {
    padding: ${({ theme }) => theme.x2spacePx}px;
    display: inline-block;
  }
  ${({ selected }) =>
    selected &&
    css`
      box-shadow: inset 0 -4px 0 0px ${({ theme }) => theme.color.brand01};
      &:disabled {
        opacity: 1;
      }
    `};
`;
